// Style =>
import "../../BaseStructure.css";
import Styled from "./pagePagination.module.css";

// type =>
import { PAGE_PAGINATION_PROPS_TYPE } from "./pagePaginationType";

const PagePagination = ({ currentPage, totalCount, pageSize, onPageChange }: PAGE_PAGINATION_PROPS_TYPE) => {
    const totalPages = Math.ceil(totalCount / pageSize);

    if (totalPages <= 1) return null;

    const getPageNumbers = (): (number | "...")[] => {
        const delta = 2;
        const pages: (number | "...")[] = [];

        const left = Math.max(2, currentPage - delta);
        const right = Math.min(totalPages - 1, currentPage + delta);

        pages.push(1);

        if (left > 2) pages.push("...");

        for (let i = left; i <= right; i++) {
            pages.push(i);
        }

        if (right < totalPages - 1) pages.push("...");

        if (totalPages > 1) pages.push(totalPages);

        return pages;
    };

    return (
        <div className={Styled.PaginationWrapper} data-aos="fade-up">
            <button
                className={`${Styled.PaginationBtn} ${currentPage === 1 ? Styled.Disabled : ""}`}
                onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                aria-label="صفحه قبل"
            >
                &#8250;
            </button>

            {getPageNumbers().map((page, index) =>
                page === "..." ? (
                    <span key={`ellipsis-${index}`} className={Styled.Ellipsis}>
                        ...
                    </span>
                ) : (
                    <button
                        key={page}
                        className={`${Styled.PaginationBtn} ${currentPage === page ? Styled.Active : ""}`}
                        onClick={() => onPageChange(page as number)}
                        aria-label={`صفحه ${page}`}
                        aria-current={currentPage === page ? "page" : undefined}
                    >
                        {page}
                    </button>
                )
            )}

            <button
                className={`${Styled.PaginationBtn} ${currentPage === totalPages ? Styled.Disabled : ""}`}
                onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                aria-label="صفحه بعد"
            >
                &#8249;
            </button>
        </div>
    );
};

export default PagePagination;
